import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { IconButton } from '@mui/material';
import {Edit } from '@mui/icons-material';
import { getFeesStructure} from '../../services/getAllApi'; // Make sure these API functions are correctly imported
import {updateFeesStructure } from '../../services/getAdminApi'


const AddFeesStructure = () => {
  const [feesStructure, setFeesStructure] = useState([]);
  const [formData, setFormData] = useState({
    without_hostel: '',
    with_hostel: '',
  });
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    fetchFeesStructure();
  }, []);

  const fetchFeesStructure = async () => {
    try {
      const response = await getFeesStructure();
      setFeesStructure(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      Swal.fire('Error', 'Failed to fetch fees structure', 'error');
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSave = async () => {
    if (!formData.without_hostel || !formData.with_hostel) {
      Swal.fire('Validation Error', 'Please fill all required fields', 'error');
      return;
    }

    const payload = {
      without_hostel: formData.without_hostel,
      with_hostel: formData.with_hostel,
    };

    try {
      if (editingId !== null) {
        const confirmEdit = await Swal.fire({
          title: 'Are you sure?',
          text: 'Do you want to update this fee structure?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, update it!',
        });

        if (confirmEdit.isConfirmed) {
          await updateFeesStructure(editingId, payload);
          Swal.fire('Success', 'Fee structure updated successfully', 'success');
        }
      }

      setFormData({
        without_hostel: '',
        with_hostel: '',
      });
      setEditingId(null);
      fetchFeesStructure();
    } catch (error) {
      Swal.fire('Error', 'Failed to save fee structure', 'error');
    }
  };

  const handleEdit = (fee) => {
    Swal.fire({
      title: 'Edit Fee Structure',
      text: 'Do you want to edit this fee structure?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, edit',
    }).then((result) => {
      if (result.isConfirmed) {
        setEditingId(fee.id);
        setFormData({
          without_hostel: fee.without_hostel,
          with_hostel: fee.with_hostel,
        });
      }
    });
  };

 

  return (
    <div>
      <div className="dashboard-heading-div">
        <p>Manage Fee Structure</p>
      </div>

      <div className="editing-container">
        <div>
          <h2 className="editing-container-heading">
            {editingId !== null ? 'Edit Fee Structure' : 'Create Fee Structure'}
          </h2>

          <div className="editing-container-form">
            <div className="editing-container-input-div">
              <label>Without Hostel Fees:</label>
              <input
                name="without_hostel"
                value={formData.without_hostel}
                onChange={handleInputChange}
                required
                placeholder="Enter Without Hostel Fees"
              />
            </div>

            <div className="editing-container-input-div">
              <label>With Hostel Fees:</label>
              <input
                name="with_hostel"
                value={formData.with_hostel}
                onChange={handleInputChange}
                required
                placeholder="Enter With Hostel Fees"
              />
            </div>
          </div>
        </div>
        <button variant="contained" color="primary" onClick={handleSave}>
          {editingId !== null ? 'Update' : 'Save'} <i className="bx bx-send"></i>
        </button>
      </div>

      <div className="table-container-registered-alumni">
        <table>
          <thead>
            <tr>
              <th>Particular</th>
              <th>Without Hostel</th>
              <th>With Hostel</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {feesStructure.map((fee) => (
              <tr key={fee.id}>
                <td>{fee.particular}</td>
                <td>{fee.without_hostel}</td>
                <td>{fee.with_hostel}</td>
                <td>
                  <IconButton color="primary" onClick={() => handleEdit(fee)}>
                    <Edit />
                  </IconButton>
                  
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AddFeesStructure;
